(() => {
  document.querySelectorAll('[data-bp8-application]').forEach(form => {
    let step = 0;
    let snapshot = null;
    const steps = [...form.querySelectorAll('[data-bp8-step]')];
    const back = form.querySelector('[data-bp8-back]');
    const next = form.querySelector('[data-bp8-next]');
    const prepare = form.querySelector('[data-bp8-prepare]');
    const result = form.querySelector('[data-bp8-result]');
    const errors = form.querySelector('[data-bp8-errors]');
    const category = form.querySelector('[name="partner_type"]');
    const other = form.querySelector('[data-bp8-other]');
    const fields = () => [...form.querySelectorAll('input[name]:not([type="checkbox"]), select[name], textarea[name]')];
    const value = field => field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent.trim() || '' : field.value.trim();
    const synchroniseOther = () => {
      if (!other) return;
      const required = ['other','other_distribution'].includes(category.value);
      other.hidden = !required;
      const input = other.querySelector('input');
      input.required = required;
      input.disabled = !required;
    };
    category.addEventListener('change', synchroniseOther);
    synchroniseOther();
    const validate = section => {
      const controls = [...section.querySelectorAll('input, select, textarea')].filter(el => !el.disabled);
      controls.forEach(el => el.removeAttribute('aria-invalid'));
      const invalid = controls.find(el => !el.checkValidity());
      errors.hidden = !invalid;
      if (invalid) {
        errors.textContent = form.dataset.error;
        invalid.setAttribute('aria-invalid','true');
        invalid.reportValidity();
        invalid.focus();
      }
      return !invalid;
    };
    const renderReview = () => {
      const review = form.querySelector('[data-bp8-review]');
      review.replaceChildren();
      fields().filter(field => !field.disabled && field.value.trim()).forEach(field => {
        const row = document.createElement('div');
        const term = document.createElement('dt');
        const detail = document.createElement('dd');
        term.textContent = field.dataset.label || field.name;
        detail.textContent = value(field);
        row.append(term,detail);
        review.append(row);
      });
    };
    const show = number => {
      step = number;
      steps.forEach((section,i) => section.hidden = i !== step);
      form.querySelectorAll('[data-bp8-progress]').forEach((el,i) => {
        el.classList.toggle('is-current',i === step);
        if (i === step) el.setAttribute('aria-current','step'); else el.removeAttribute('aria-current');
      });
      back.hidden = step === 0;
      next.hidden = step === 2;
      prepare.hidden = step !== 2;
      errors.hidden = true;
      if (step === 2) renderReview();
    };
    const focusStep = () => {
      const target = steps[step].querySelector('input:not(:disabled),select,textarea,h3');
      target?.focus({preventScroll:true});
      if (window.matchMedia('(max-width:760px)').matches) form.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    };
    next.addEventListener('click',() => {if(validate(steps[step])) {show(step+1);focusStep();}});
    back.addEventListener('click',() => {show(Math.max(0,step-1));focusStep();});
    form.addEventListener('input',() => {result.hidden = true; snapshot = null;});
    form.addEventListener('bp8:prefill',() => {result.hidden = true;snapshot = null;});
    form.addEventListener('submit',event => {
      event.preventDefault();
      if (step !== 2) {if(validate(steps[step])) show(step+1);return;}
      for (let i=0;i<steps.length;i++) {
        const invalid = [...steps[i].querySelectorAll('input,select,textarea')].some(el => !el.disabled && !el.checkValidity());
        if (invalid) {show(i);validate(steps[i]);return;}
      }
      const reference = 'BP8-'+crypto.randomUUID().slice(0,8).toUpperCase();
      const timestamp = new Date().toISOString();
      const rows = fields().filter(field => !field.disabled).map(field => ({code:field.name,label:field.dataset.label || field.name,value:field.value.trim(),display:value(field)}));
      snapshot = {application_reference:reference,program:form.dataset.program,prepared_at:timestamp,partner_type_code:category.value,source:'sothing-business-v8',...Object.fromEntries(rows.map(row => [row.code,row.value]))};
      const text = ['SOTHING '+form.dataset.programName+' application','Application reference: '+reference,'Program: '+form.dataset.program,'Prepared at (UTC): '+timestamp,'Partner type code: '+category.value,'Source: sothing-business-v8','',...rows.filter(row => row.value).map(row => row.label+' ['+row.code+']: '+row.display),'','Acknowledgement: Applicant confirms the details and requests partnership review. No purchase or trade agreement is created.'].join('\n');
      const email = form.querySelector('[data-bp8-email]');
      email.href = 'mailto:marketing@sothing.com?subject='+encodeURIComponent('SOTHING '+form.dataset.programName+' | '+category.value+' | '+reference)+'&body='+encodeURIComponent(text);
      form.querySelector('[data-bp8-output]').value = text;
      form.querySelector('[data-bp8-status]').textContent = '';
      result.hidden = false;
      result.scrollIntoView({block:'nearest',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    });
    form.querySelector('[data-bp8-copy]').addEventListener('click',async () => {
      if (!snapshot) return;
      try {await navigator.clipboard.writeText(form.querySelector('[data-bp8-output]').value);form.querySelector('[data-bp8-status]').textContent = form.dataset.copied;}
      catch {form.querySelector('[data-bp8-output]').select();form.querySelector('[data-bp8-status]').textContent = form.dataset.copyFailed;}
    });
    form.querySelector('[data-bp8-download]').addEventListener('click',() => {
      if (!snapshot) return;
      const escape = v => '"'+String(v ?? '').replace(/"/g,'""')+'"';
      const keys = Object.keys(snapshot);
      const csv = '\uFEFF'+keys.map(escape).join(',')+'\r\n'+keys.map(key => escape(snapshot[key])).join(',')+'\r\n';
      const url = URL.createObjectURL(new Blob([csv],{type:'text/csv;charset=utf-8'}));
      const anchor = document.createElement('a');anchor.href = url;anchor.download = snapshot.application_reference+'.csv';anchor.click();setTimeout(() => URL.revokeObjectURL(url),1000);
    });
    show(0);
  });
})();
